import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

export const firebaseConfig = {
  projectId: 'wyrd-grove-art',
  appId: '1:273405194524:web:7abdbcc127de5d1aa9cad9',
  storageBucket: 'wyrd-grove-art.firebasestorage.app',
  apiKey: 'AIzaSyBy2rDTJdqJl6SZ4b0E-D5ie3UgBCBGQ0c',
  authDomain: 'wyrd-grove-art.firebaseapp.com',
  messagingSenderId: '273405194524',
}

export const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const storage = getStorage(app)
